function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.998.151a.6.6 0 01.051.847l-11.52 13a.6.6 0 01-.851.047l-6.48-5.85a.6.6 0 01.804-.89l6.03 5.444L18.152.202a.6.6 0 01.847-.051z",
  fill: "currentColor"
});

function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC45OTc5IDAuMTUwOTUyQzE5LjI0NTkgMC4zNzA3MjQgMTkuMjY4OCAwLjc0OTkzMiAxOS4wNDkxIDAuOTk3OTM5TDcuNTI5MDYgMTMuOTk3OUM3LjQyMjg4IDE0LjExNzggNy4yNzMyMyAxNC4xOTAyIDcuMTEzMzkgMTQuMTk5MUM2Ljk1MzU1IDE0LjIwOCA2Ljc5Njc3IDE0LjE1MjYgNi42Nzc5NCAxNC4wNDU0TDAuMTk3OTQzIDguMTk1MzdDLTAuMDQ4MDIzIDcuOTczMzIgLTAuMDY3NDA4NiA3LjU5MzkxIDAuMTU0NjQ0IDcuMzQ3OTRDMC4zNzY2OTcgNy4xMDE5OCAwLjc1NjEwMSA3LjA4MjU5IDEuMDAyMDcgNy4zMDQ2NUw3LjAzMjU3IDEyLjc0ODlMMTguMTUwOSAwLjIwMjA3NUMxOC4zNzA3IC0wLjA0NTkzMTIgMTguNzQ5OSAtMC4wNjg4MTk4IDE4Ljk5NzkgMC4xNTA5NTJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgIconCheck as ReactComponent };